import { render } from "./ai-prompt-settings.vue?vue&type=template&id=19944130&scoped=true"
import script from "./ai-prompt-settings.vue?vue&type=script&lang=js"
export * from "./ai-prompt-settings.vue?vue&type=script&lang=js"

import "./ai-prompt-settings.vue?vue&type=style&index=0&id=19944130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19944130"]])

export default __exports__